import moment from 'moment';

export function fromDR(dr) {
    let dates = dr.split(',');
    return {
        startDate: moment(dates[0]),
        endDate: moment(dates[1]),
    };
}

export function toDR (dates) {
    let startDate = dates.startDate;
    let endDate = dates.endDate;
    if (startDate && endDate) {
        startDate = moment(dates.startDate).format('YYYY-MM-DD');
        endDate = moment(dates.endDate).format('YYYY-MM-DD');
        return `${startDate},${endDate}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils.js